import React, { ComponentProps, useMemo } from "react";

import { useAppDispatch } from "cortex/ui/src/hooks";
import { createPromiseApiAction } from "cortex/ui/src/redux-store/api-sagas";
import { LOAD_NETWORK } from "cortex/ui/src/redux-store/networks";
import { SimpleFetchController } from "cortex/ui/src/ui/fetch/fetch-controller";

type SimpleFetchControllerProps = ComponentProps<typeof SimpleFetchController>;

export interface FetchNetworkControllerProps
  extends Omit<SimpleFetchControllerProps, "fetchObject" | "objectId"> {
  networkId: number | string;
}

function FetchNetworkController({
  networkId,
  ...restProps
}: FetchNetworkControllerProps) {
  const dispatch = useAppDispatch();

  const objectId = useMemo(() => String(networkId), [networkId]);

  const fetchObject = useMemo(
    () => (id: number | string) =>
      createPromiseApiAction(dispatch, LOAD_NETWORK, [id]),
    [dispatch],
  );

  return (
    <SimpleFetchController
      {...restProps}
      fetchObject={fetchObject}
      objectId={objectId}
    />
  );
}

export { FetchNetworkController };
export default FetchNetworkController;
